import React from 'react';
import cx from 'classnames';

const Separator = ({ className }) => <hr className={cx('separator', className)} />;

export default Separator;
